// Environment helpers
const development = process.env.NODE_ENV === 'development'
const production = process.env.NODE_ENV === 'production'

export {
  development,
  production
}
